<template>
  <div id="notFound">
    <img src="../assets/img/404.png" class="mx-auto d-block">
  </div>
</template>
<script>
export default {
  name: 'NotFound'
}
</script>

<style>
#notFound {
  padding: 2em;
  color: black;
}
</style>
